import type { RefObject } from 'react';
import { findTransitionController } from '../../../../util/core-transition-component';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';
import type { TextRef } from '../../../atoms/text/Text.data';
import type { PrimaryButtonRef } from '../../../atoms/primary-button/PrimaryButton.data';
import gsap from 'gsap';

interface ServicesRefs {
  elementRef?: RefObject<HTMLElement | null>;
  indexRef: RefObject<HeadingRef | null>;
  titleRef: RefObject<HeadingRef | null>;
  subtitleRef: RefObject<HeadingRef | null>;
  descriptionRef: RefObject<TextRef | null>;
  linkRef: RefObject<PrimaryButtonRef | null>;
}

export function setupTransitionInTimelineText(
  timeline: gsap.core.Timeline,
  { elementRef, indexRef, titleRef, subtitleRef, descriptionRef, linkRef }: ServicesRefs,
): void {
  const index = findTransitionController(indexRef);
  const title = findTransitionController(titleRef);
  const subtitle = findTransitionController(subtitleRef);
  const description = findTransitionController(descriptionRef);
  const link = findTransitionController(linkRef);

  if (elementRef?.current) {
    timeline.to(elementRef.current, {
      opacity: 1,
      pointerEvents: 'all',
      onComplete: () => {
        gsap.set(elementRef.current, {
          pointerEvents: 'all',
        });
      },
      onReverseComplete: () => {
        gsap.set(elementRef.current, {
          pointerEvents: 'none',
        });
      },
    });
  }

  if (index) {
    timeline.add(index.getTimeline('in') as gsap.core.Timeline, 0);
  }
  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline, 0);
  }
  if (subtitle) {
    timeline.add(subtitle.getTimeline('in') as gsap.core.Timeline, 0.1);
  }
  if (description) {
    timeline.add(description.getTimeline('in') as gsap.core.Timeline, 0.2);
  }
  if (link) {
    timeline.add(link.getTimeline('in') as gsap.core.Timeline, 0.3);
  }
}

export function setupTransitionOutTimelineText(
  timeline: gsap.core.Timeline,
  { elementRef, indexRef, titleRef, subtitleRef, descriptionRef, linkRef }: ServicesRefs,
): void {
  const index = findTransitionController(indexRef);
  const title = findTransitionController(titleRef);
  const subtitle = findTransitionController(subtitleRef);
  const description = findTransitionController(descriptionRef);
  const link = findTransitionController(linkRef);

  if (elementRef?.current) {
    timeline.to(elementRef.current, {
      clearProps: 'pointerEvents',
      opacity: 0,
      onComplete: () => {
        gsap.set(elementRef.current, {
          clearProps: 'pointerEvents',
        });
      },
      onReverseComplete: () => {
        gsap.set(elementRef.current, {
          pointerEvents: 'all',
        });
      },
    });
  }

  if (index) {
    timeline.add(index.getTimeline('out') as gsap.core.Timeline, 0);
  }
  if (title) {
    timeline.add(title.getTimeline('out') as gsap.core.Timeline, 0);
  }
  if (subtitle) {
    timeline.add(subtitle.getTimeline('out') as gsap.core.Timeline, 0);
  }
  if (description) {
    timeline.add(description.getTimeline('out') as gsap.core.Timeline, 0);
  }
  if (link) {
    timeline.add(link.getTimeline('out') as gsap.core.Timeline, 0);
  }
}
